import RpcClass from "../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.organization.Departments';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class Departments extends RpcClass{

    /**
     *  @class Departments
     *  @alias module:src/server/com/silkplm/rpc/organization/Departments.Departments
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param parentId {string} 
     * @param name {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Department.Department>}
     */
     addDepartment(parentId, name) {
            return RpcClass.rpcCall('/rpc/organization/departments/add-department', [parentId, name]);
    }
    /** 
     * @async
     * @param departmentId {string} 
     * @param newParentId {string} 
     * @param deleteChildren {boolean} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteDepartment(departmentId, newParentId, deleteChildren) {
            return RpcClass.rpcCall('/rpc/organization/departments/delete-department', [departmentId, newParentId, deleteChildren]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DepartmentInfo.DepartmentInfo[]>}
     */
     departmentsList() {
            return RpcClass.rpcCall('/rpc/organization/departments/departments-list', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DepartmentInfo.DepartmentInfo[]>}
     */
     departmentsTree() {
            return RpcClass.rpcCall('/rpc/organization/departments/departments-tree', []);
    }
    /** 
     * @async
     * @param departmentId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Department.Department>}
     */
     getDepartmentById(departmentId) {
            return RpcClass.rpcCall('/rpc/organization/departments/get-department-by-id', [departmentId]);
    }
    /** 
     * @async
     * @param departmentId {string} 
     * @param targetParent {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     moveDepartment(departmentId, targetParent) {
            return RpcClass.rpcCall('/rpc/organization/departments/move-department', [departmentId, targetParent]);
    }
    /** 
     * @async
     * @param departmentId {string} 
     * @param newName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     rename(departmentId, newName) {
            return RpcClass.rpcCall('/rpc/organization/departments/rename', [departmentId, newName]);
    }
    /** 
     * @async
     * @param parentId {string} 
     * @param name {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateDepartmentName(parentId, name) {
            return RpcClass.rpcCall('/rpc/organization/departments/validate-department-name', [parentId, name]);
    }
    /** 
     * @async
     * @param parentId {string} 
     * @param name {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/InputValidationResult.InputValidationResult>}
     */
     validateNewDepartment(parentId, name) {
            return RpcClass.rpcCall('/rpc/organization/departments/validate-new-department', [parentId, name]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.organization.Departments';
metadata.__type_short__ = 'Departments';
Departments.prototype.__metadata__ = metadata;

Departments.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/organization/Departments */
export default Departments

export { Departments }
